import validateMcapMp4 from './mcapMp4';

const FORMAT_VALIDATORS = {
    'mcap/mp4': validateMcapMp4,
};

export function resolveDataFormat(dataFormat) {
    return dataFormat || 'mcap/mp4';
}

export function validateFilesForFormat(files, dataFormat) {
    const resolvedFormat = resolveDataFormat(dataFormat);
    const validator = FORMAT_VALIDATORS[resolvedFormat];
    if (!validator) {
        return {
            episodeKeys: [],
            errors: [`Unsupported data format: ${resolvedFormat}`],
        };
    }
    return validator(files);
}
